export default function isPayment(profile) {
    return profile?.payment_date_active > Date.now() / 1000;
}